import Breadcrumbs from '@/components/Breadcrumbs'
import Button from '@/components/Button'
import DataElementSharingModal2 from '@/components/DataElementSharingModal2/index'
import Portal from '@/components/Portal'
import useModal from '@/hooks/use-modal'
import usePage from '@/hooks/use-page'
import usePrincipals from '@/hooks/use-principal/index'
import { useLocation, useNavigate, useParams } from '@/lib/router-dom'
import { getPrincipalCount } from '@/utils/principal-storage'
import { getUseCaseId } from "@/utils/use-case-storage"
import { useEffect, useMemo, useState } from 'react'

const Page = () => {

	const [pageTitle] = useState('Success')

	const { useCaseId } = useParams()
	const useCase = useMemo(() => getUseCaseId(useCaseId), [useCaseId]);
	const [subPageTitle] = useState(useCase.name)
	const [principalCount, setPrincipalCount] = useState(getPrincipalCount())

	const { breadcrumbsItems } = usePage({ title: pageTitle, breadcrumbs: ['Dashboard', subPageTitle, 'Initiate Data Element Sharing'] })
	const { find: findPrincipals, loading: loadingPrincipals } = usePrincipals()

	const { currentState } = useLocation()

	const findPrincipalCount = async () => {
		if (principalCount > 0) return principalCount;
		if (loadingPrincipals) return;

		const principalItems = await findPrincipals()
		setPrincipalCount(principalItems?.length ?? 0)
	}

	useEffect(() => {
		findPrincipalCount();
	}, [])

	const types = {
		noProvider: "no-provider",
		provider: "provider",
	}

	const { goTo } = useNavigate()
	const providerType = currentState

	/*=================================================
		Modal
	/================================================*/

	const { visible: initiateDataElementModal, show: showInitiateDataElementModal, hide: hideInitiateDataElementModal } = useModal()

	/*=================================================
		Navigate
	/================================================*/

	function backToDashboard() {
		goTo(`/use-cases/${useCaseId}/dashboard`)
	}

	return (
		<>
			<div className="layout-feedback">
				<div className="layout-feedback__header layout-feedback__center">
					{
						providerType?.type === types.noProvider && (
							<>
								{providerType.dataElement} has been <br />
								successfully added
							</>
						)
					}

					{
						providerType?.type === types.provider && (
							<>
								A request has been sent to the <br />
								nominated pitstop(s) for their approval
							</>
						)
					}
				</div>

				<div className="layout-feedback__content">
					<img src="/img/success.png" />
				</div>

				<div className="layout-feedback__footer">
					<Button data-testid="backButton" sizing='Medium' text="Back to Use Case Dashboard" round ghost
						submit={() => backToDashboard()}
					/>

					<Button data-testid="showModal" sizing='Medium' text="Add Another Data Element" round
						submit={() => showInitiateDataElementModal()}
					/>
				</div>
			</div>

			<DataElementSharingModal2
				isVisible={initiateDataElementModal}
				hideModal={hideInitiateDataElementModal}
				useCaseId={useCaseId}
				useCaseAgentStatus={useCase.agentStatus}
				principalCount={principalCount}
			/>
		</>
	)
}
export default Page
